// This must be the first line in src/index.js
// https://github.com/facebook/create-react-app/blob/master/packages/react-app-polyfill/README.md
import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import { CookieBanner, GlobalStyle, GlobalMapStyles } from 'shared';
import { Route, Router } from 'react-router-dom';

import 'normalize.css';
import './globalStyles.css';

import RRP from './RRP';
import Page from './Page';
import * as serviceWorker from './serviceWorker';
import { ContextProvider } from './components/context';

import history from './utils/history';

import './i18n';

import { mapRoot } from './utils';


window.additionalApiParams = '';

if ('URLSearchParams' in window) {
	const params = new URLSearchParams(window.location.search);
	if (params.has('apiDomain')) {
		window.additionalApiParams = `domain=${params.get('apiDomain')}`;
	}

	if (params.has('themeroutesDomain')) {
		window.additionalThemeroutesParams = `domain=${params.get('themeroutesDomain')}`;
	}
}

ReactDOM.render(
	<React.StrictMode>
		<GlobalStyle />
		<Router history={history}>
			<Route path={`${mapRoot}(@.+)?`}>
				<GlobalMapStyles />
				<ContextProvider>
					<RRP />
				</ContextProvider>
			</Route>
			<Route path="/" exact>
				<Page />
			</Route>
		</Router>
		<CookieBanner />
	</React.StrictMode>,
	document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
